import React from 'react'
import Layout from '../../components/layout'
import Container from '../../components/container'
// import styled from '@emotion/styled'

const WildlifePage = () => {
  return (
    <Layout>
      <Container>
        <p>This is the Wildlife Page</p>
      </Container>
    </Layout>
  );
}

export default WildlifePage
